module.exports = __webpack_public_path__ + "img/VietQR1.09f26152.svg";